import { render } from "./MorePage.vue?vue&type=template&id=4a9feb66&scoped=true"
import script from "./MorePage.vue?vue&type=script&lang=js"
export * from "./MorePage.vue?vue&type=script&lang=js"

import "./MorePage.vue?vue&type=style&index=0&id=4a9feb66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9feb66"]])

export default __exports__